export default "__VITE_ASSET__CJfVFpNS__"